/**
 * Created by tofael on 11/6/17.
 */
import React from 'react';
import {connect} from 'react-redux';

import api from '../utility/api';
import MissionView from '../screens/mission-view';
import HiddenDialogs from '../screens/mission-view/hidden-dialogs.component';
import { asyncStart, asyncEnd, showFeedback } from '../actions/application';

class ViewMission extends React.Component {

  constructor() {
    super(...arguments);
    this.state = {
      mission: null,
      reportFile: null,
      fileType: '',
      activityList: [],
      prescriptionDialogOpen: false,
      reportPreviewDialogOpen: false,
      prescription: {
        cc :'',
        rx: '',
        examinations: '',
        advice: '',
        investigations :'',
        s3_key: ''
      }
    };
  }

  componentWillMount(){
    this.setMission();
  }

  setMission(){
    let mission = this.getMissionObject();
    this.getMissionActivity(mission.id);
  }

  handlePrescriptionData(prescription){
    if (prescription) {
      let {cc, rx, examinations, advice, investigations, display_s3_key, file_data} = prescription;
      this.setState({
        ...this.state,
        prescription: {
          cc,
          rx,
          file_data,
          examinations,
          advice,
          investigations,
          s3_key: display_s3_key
        }
      });
    }
  }

  displayFeedBack(message){
    this.props.dispatch(showFeedback({message: message}));
  }

  dispatchAction(action){
    this.props.dispatch(action());
  }

  togglePrescriptionDialog = (prescription) => {
    this.handlePrescriptionData(prescription);
    this.setState({ prescriptionDialogOpen: !this.state.prescriptionDialogOpen });
  };

  getMissionId(){
    return this.props.params.id;
  }

  getMissionObject(){
    return this.props.mission;
  }

  getMissionDetails(){
    this.dispatchAction(asyncStart);
    let missionId = this.getMissionId();
    api.getMissionDetails(missionId)
      .then((mission)=>{
        this.dispatchAction(asyncEnd);
        this.setState({mission});
        this.handlePrescriptionData(mission);
      })
      .catch(error => {
        this.dispatchAction(asyncEnd);
        this.displayFeedBack(error.message);
      });
  }

  getMissionActivity(missionId){
    api.getMissionActivity(missionId)
      .then((activityList)=>{
        this.setState({activityList});
      })
      .catch((error)=>{
        this.displayFeedBack(error.message);
      })
  }

  toggleReportPreviewDialog = (reportFile, fileType) => {
    this.setState({ reportFile, fileType, reportPreviewDialogOpen: !this.state.reportPreviewDialogOpen });
  };

  render() {
    const {mission,toggleReviewDialog, showReport, submitReview, onChange, review, reviewDialogOpen, comment, endMissionDialogOpen, reopenMissionDialogOpen, deleteReport, endMission, reopenMission, toggleEndMissionDialog, toggleReopenMissionDialog} = this.props;
    let {prescription, reportPreviewDialogOpen, prescriptionDialogOpen, reportFile, activityList, fileType} = this.state;
    return (
      <div>
        <MissionView
          mission={mission}
          showReport={showReport}
          activityList={activityList}
          deleteReport={deleteReport}
          togglePrescriptionDialog={this.togglePrescriptionDialog.bind(this)}
          toggleReportPreviewDialog={this.toggleReportPreviewDialog.bind(this)}
        />
        <HiddenDialogs
          mission={mission}
          comment={comment}
          onChange={onChange}
          review={review}
          reopenMission={reopenMission}
          endMission={endMission}
          endMissionDialogOpen={endMissionDialogOpen}
          reopenMissionDialogOpen={reopenMissionDialogOpen}
          toggleEndMissionDialog={toggleEndMissionDialog}
          toggleReopenMissionDialog={toggleReopenMissionDialog}
          prescription={prescription}
          reviewDialogOpen={reviewDialogOpen}
          submitReview={submitReview}
          toggleReviewDialog={toggleReviewDialog}
          reportFile={reportFile}
          fileType={fileType}
          prescriptionDialogOpen={prescriptionDialogOpen}
          reportPreviewDialogOpen={reportPreviewDialogOpen}
          toggleReportPreviewDialog={this.toggleReportPreviewDialog}
          togglePrescriptionDialog={this.togglePrescriptionDialog.bind(this)}
        />
      </div>
    );

  }

}

function mapStateToProps(state) {
  return state.application;
}

export default connect(mapStateToProps, null)(ViewMission);


// WEBPACK FOOTER //
// ./src/containers/mission-view.js